module.exports = __webpack_public_path__ + "img/u6086-4.4aa880c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutMe_img/u6086-4.png
// module id = SXvE
// module chunks = 0